import { Component, Input } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { serviceConstants } from 'src/app/constants/service.constants';
import { DateObject, Document_Upload_File } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { ReviewService } from 'src/app/services/common/review.service';
import * as $ from 'jquery';
import { FileService } from 'src/app/services/file.service';
import { DatePipe } from '@angular/common';
import { CorrespondenceComponent } from '../correspondence/correspondence.component';
import { EmailComposeComponent } from '../correspondence/email-compose/email-compose.component';

@Component({
  selector: 'app-application-budget',
  templateUrl: './application-budget.component.html',
  styleUrl: './application-budget.component.scss',
})
export class ApplicationBudgetComponent {

  @Input() public Content: any;
  applicationId: string;
  budgetForm: UntypedFormGroup;
  isStartDateModified: boolean = false;
  isEndDateModified: boolean = false;
  Planned_Payment_Date: DateObject;
  minDate: Date | null = null;
  CurrentDate: Date;
  disabledDates: Date[] = [];
  files: any[] = [];
  milestoneOptions: any[] = [];
  milestoneTypeErrors: boolean[] = [];
  ModuleId: string;
  SubModule: string;
  scheduleTouchedOnce: boolean = false;
  hasMileStoneAvailable: boolean;
  heading: string = null;


  constructor(public modalRef: NgbActiveModal,
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private budgetService: ReviewService,
    private commonService: CommonService,
    public fileService: FileService,
    public datepipe: DatePipe
  ) {
    this.buildForm();
  }

  ngOnInit() {
    this.ModuleId = this.Content?.Module;
    this.SubModule = this.Content?.SubModule;
    this.applicationId = this.Content?.ApplicationID;
      
    if (this.applicationId) {
      // Load budget data for the application
      this.loadBudgetData(this.applicationId);
      this.loadMilestones(this.applicationId);
    }
    this.minDate = new Date();
    this.CurrentDate = new Date();
  }

  private buildForm(): void {
    this.budgetForm = this.fb.group({
      totalFundRequested: [null, Validators.required],
      totalFundAllocated: [null, Validators.required],
      totalFundConsumed: [null, Validators.required],
      totalFundRetrieved: [null, Validators.required],
      ModuleId: [this.ModuleId],
      SubModule: [this.SubModule],
      applicationID: [this.applicationId],
      paymentSchedules: this.fb.array([
        this.createPaymentScheduleGroup()
      ])
    });
  }

  private createPaymentScheduleGroup(): UntypedFormGroup {
    return this.fb.group({
      Id: [""],
      amount: [null, [Validators.required]],
      plannedPaymentDate: [null, Validators.required],
      actualPaymentDate: [null, Validators.required],
      allocated: [null, Validators.required],
      fundReceivedBack: [null, Validators.required],
      paymentStatus: [null, Validators.required],
      milestone: [false],
      milestoneType: [null],
      notes: [''],
      attachments: [[]],
      planned_payment_Date_DateO: [null],
      actual_payment_Date_DateO: [null],
    });
  }

  get paymentSchedules(): UntypedFormArray {
    return this.budgetForm.get('paymentSchedules') as UntypedFormArray;
  }

  addPaymentSchedule() {
    this.scheduleTouchedOnce = true;
    this.paymentSchedules.push(this.createPaymentScheduleGroup());
  }

  private loadBudgetData(applicationId: string): void {
    if (!this.applicationId) return;

    this.budgetService.EditReview(`api/ISTAllRequests/GetAllBudgetFundDetails?Id=${this.applicationId}&ModuleId=${this.ModuleId}`).subscribe({
      next: (res: any) => {
        if (res?.Status === 0 && res?.Data) {
          const { hasAllRequestAvailable, hasMileStoneAvailable, ISTData, ManualData, PaymentSchedules } = res.Data;
          this.hasMileStoneAvailable = hasMileStoneAvailable;

          this.budgetForm.patchValue({
            applicationID: this.applicationId,
            ModuleId: this.ModuleId,
            SubModule: this.SubModule
          });

          console.log(this.budgetForm.getRawValue());

          if (hasAllRequestAvailable == true) {
            this.budgetForm.controls['totalFundRequested'].setValue(ISTData.TotalFundRequested);
            this.budgetForm.controls['totalFundAllocated'].setValue(ISTData.TotalFundAllocated);
            this.budgetForm.controls['totalFundConsumed'].setValue(ISTData.TotalFundConsumed);
            this.budgetForm.controls['totalFundRetrieved'].setValue(ISTData.TotalFundReturned);

            this.budgetForm.controls['totalFundRequested'].disable();
            this.budgetForm.controls['totalFundAllocated'].disable();
            this.budgetForm.controls['totalFundConsumed'].disable();
            this.budgetForm.controls['totalFundRetrieved'].disable();
          } else {
            this.budgetForm.controls['totalFundRequested'].setValue(ManualData?.totalFundRequested ?? null);
            this.budgetForm.controls['totalFundAllocated'].setValue(ManualData?.totalFundAllocated ?? null);
            this.budgetForm.controls['totalFundConsumed'].setValue(ManualData?.totalFundConsumed ?? null);
            this.budgetForm.controls['totalFundRetrieved'].setValue(ManualData?.totalFundRetrieved ?? null);

            this.budgetForm.controls['totalFundRequested'].enable();
            this.budgetForm.controls['totalFundAllocated'].enable();
            this.budgetForm.controls['totalFundConsumed'].enable();
            this.budgetForm.controls['totalFundRetrieved'].enable();
          }

          const originalMinDate = this.minDate;
          this.minDate = null; // Allow patching past dates

          this.paymentSchedules.clear();
          if (PaymentSchedules?.length) {
            PaymentSchedules.forEach((schedule: any, index: number) => {
              const plannedDate = schedule.plannedPaymentDate ? new Date(schedule.plannedPaymentDate) : null;
              const actualDate = schedule.actualPaymentDate ? new Date(schedule.actualPaymentDate) : null;

              const group = this.fb.group({
                Id: [schedule.Id],
                amount: [schedule.amount],
                plannedPaymentDate: [plannedDate instanceof Date && !isNaN(plannedDate.getTime()) ? plannedDate : null],
                actualPaymentDate: [actualDate instanceof Date && !isNaN(actualDate.getTime()) ? actualDate : null],
                allocated: [schedule.allocated],
                fundReceivedBack: [schedule.fundReceivedBack],
                paymentStatus: [schedule.paymentStatus ?? null],
                milestone: [schedule.milestone ?? false],
                milestoneType: [schedule.milestoneType ?? null],
                notes: [schedule.notes ?? ''],
                attachments: [schedule.attachments ?? []]
              });

              // Push the group to FormArray
              this.paymentSchedules.push(group);

              // Clear milestoneType if milestone is false
              if (!group.get('milestone')?.value) {
                group.get('milestoneType')?.setValue(null);
              }

              // Set up reactive logic for milestoneType and milestone checkbox
              group.get('milestoneType')?.valueChanges.subscribe(value => {
                if (value) this.milestoneTypeErrors[index] = false;
              });

              group.get('milestone')?.valueChanges.subscribe(isChecked => {
                if (!isChecked) {
                  group.get('milestoneType')?.reset(); // this clears the value when unchecked
                  this.milestoneTypeErrors[index] = false;
                }
              });
            });

          }

          //this.minDate = originalMinDate;

        }
      },
      error: err => {
        console.error('Error loading budget data:', err);
      }
    });
  }

  private loadMilestones(applicationId: string): void {
    this.budgetService.EditReview('api/ISTAllRequests/GetMyRequestsMilestones?Id='+applicationId).subscribe({
      next: (res: any) => {
        if (res?.Status === 0 && res?.Data) {
          this.milestoneOptions = res.Data.map(m => ({
            label: m.TITLE,
            value: m.ID
          }));
        }
      },
      error: err => {
        //console.error('Error loading milestones:', err);
      }
    });
  }


  DateSelect(event, type, index) {
    let Full_Date = {
      Day: event.getDate(),
      Month: event.getMonth() + 1,
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true
    };

    if (type === "planned") {
      this.paymentSchedules.at(index).get("planned_payment_Date_DateO")?.setValue(Full_Date);
    } else {
      this.paymentSchedules.at(index).get("actual_payment_Date_DateO")?.setValue(Full_Date);
    }
  }




  GetStartDate(): DateObject {
    let formModel = this.budgetForm.getRawValue();
    const lDate = new Date(formModel.PlannedEndDate);
    if ((this.CompareDates(this.CurrentDate, lDate) || this.Planned_Payment_Date == null || this.Planned_Payment_Date == undefined) &&
      formModel.PlannedEndDate != null) {
      this.Planned_Payment_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: false
      }
    }
    else {
      this.Planned_Payment_Date = {
        Day: lDate.getDate(),
        Month: lDate.getMonth() + 1,
        Year: lDate.getFullYear(),
        Hours: 23,
        Minutes: 59,
        Seconds: 59,
        IsEndDate: true,
        HasValue: true,
        IsDateModified: true
      }
    }
    return this.Planned_Payment_Date
  }

  CompareDates(oldDate: any, newDate: any): boolean {
    if (oldDate != undefined && oldDate != null && oldDate != '') {
      let oDt = oldDate.getDate().toString() + oldDate.getMonth().toString() + oldDate.getFullYear().toString();
      let nDt = newDate.getDate().toString() + newDate.getMonth().toString() + newDate.getFullYear().toString();
      if (oDt == nDt)
        return true;
      else
        return false;
    }
    else
      return false;
  }

  preventInvalidInput(event: KeyboardEvent): void {
    const invalidChars = ['e', 'E', '+', '-'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
      return;
    }

    const allowedKeys = [
      'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Home', 'End'
    ];
    if (allowedKeys.includes(event.key)) {
      return; // allow default behavior
    }

    const input = event.target as HTMLInputElement;
    const { value, selectionStart, selectionEnd } = input;

    // Simulate the value if the key is allowed
    const newValue =
      value.substring(0, selectionStart ?? 0) +
      event.key +
      value.substring(selectionEnd ?? 0);

    // Allow numbers with optional one dot and up to 2 decimal places
    //Beacuse In Number(38,2) so 36(Values) and 2(decimal values)
    const decimalRegex = /^\d{0,29}(\.\d{0,2})?$/;

    if (!decimalRegex.test(newValue)) {
      event.preventDefault();
    }
  }

  preventInvalidPaste(event: ClipboardEvent): void {
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const isInvalid = !/^\d*\.?\d{0,1}$/.test(clipboardData);
    if (isInvalid) {
      event.preventDefault();
    }
  }

  uploadchange(event: any, i: number, schedule: any): void {
    let isExe = false;
    let isOver50MB = false;

    const files = event.target.files;
    if (!files || files.length === 0) return;

    const control = this.budgetForm.get('paymentSchedules') as UntypedFormArray;
    const scheduleControl = control.at(i);
    const attachmentsControl = scheduleControl.get('attachments');

    let attachments = attachmentsControl?.value ? [...attachmentsControl.value] : [];

    for (let file of files) {
      const fileName = file.name;
      const fileExt = fileName.split('.').pop()?.toLowerCase();
      const fileSize = file.size;

      if (fileExt === 'exe') {
        isExe = true;
        continue;
      }

      if (fileSize > 52428800) { // 50MB
        isOver50MB = true;
        continue;
      }

      this.saveTempFiles(file).subscribe((result: any) => {
        const response = result?.Data?.[0];
        if (!response?.FileID) return;

        const uploadFile = new Document_Upload_File();
        uploadFile.ID = response.FileID;
        uploadFile.DOCUMENT_NAME = fileName;
        uploadFile.File = null;
        uploadFile.Status = "Add";
        uploadFile.UploadedDate = this.datepipe.transform(new Date(), 'dd-MMM-yyyy') ?? "";

        const alreadyExists = attachments.some((att: any) =>
          att.DOCUMENT_NAME.toLowerCase() === uploadFile.DOCUMENT_NAME.toLowerCase() && att.Status !== 'Delete'
        );

        if (alreadyExists) {
          this.commonService.ValidationBanner("File already exists with " + uploadFile.DOCUMENT_NAME + ". Please upload a unique file name.");
        } else {
          attachments.push(uploadFile);
          attachmentsControl?.patchValue(attachments);
          attachmentsControl?.markAsDirty();
        }
      });
    }

    // Show appropriate validation messages after processing all files
    if (isExe && isOver50MB) {
      this.commonService.ValidationBanner("The system does not support .exe files and max allowed size is 50MB.");
    } else if (isExe) {
      this.commonService.ValidationBanner("The system does not support .exe files.");
    } else if (isOver50MB) {
      this.commonService.ValidationBanner("File exceeds max size of 50MB.");
    }
  }

  saveTempFiles(selectedFiles: any) {
    const formData = new FormData();
    formData.append(`files`, selectedFiles);
    return this.fileService.uploadMultiFiles(formData, "");
  }

  downloadFile(ID) {

    let url = serviceConstants.apiURL + "api/ISTFileAttachments/Downloadfile?FileID=" + ID;
    window.open(url);
  }

  ViewFile(fileID, fileName) {
    this.commonService.previewFile(fileID, fileName, "med");
  }

  isAllowedExtensionFile(Filename) {
    return this.commonService.isAllowedExtension(Filename);
  }

  showFiles() {
    let files = '';
    for (let i = 0; i < this.files.length; i++) {
      files += this.files[i].name;
      if (!(this.files.length - 1 === i)) {
        files += ',';
      }
    }
    return files;
  }

  getVisibleAttachments(i: number): any[] {
    const attachmentsControl = this.paymentSchedules.at(i).get('attachments');
    if (!attachmentsControl) return [];
    return (attachmentsControl.value || []).filter((doc: any) => doc.Status !== 'Delete');
  }

  DeleteUpload(file: any, i: number): void {
    const attachmentsControl = this.paymentSchedules.at(i).get('attachments');
    if (!attachmentsControl) return;

    const attachments = attachmentsControl.value || [];

    const originalIndex = attachments.findIndex((doc: any) =>
      doc.DOCUMENT_NAME === file.DOCUMENT_NAME &&
      doc.TRANSACTION_ID === file.TRANSACTION_ID
    );

    if (originalIndex !== -1) {
      if (attachments[originalIndex].Status === 'Add') {
        attachments.splice(originalIndex, 1); // remove newly added
      } else {
        attachments[originalIndex].Status = 'Delete'; // mark for deletion
      }

      attachmentsControl.setValue([...attachments]); // trigger change detection
      attachmentsControl.markAsDirty();
    }
  }

  validateControls(): boolean {
    let isValid = true;
    const messages: string[] = [];
    this.milestoneTypeErrors = [];

    const highlight = (id: string) => {
      $(`#${id}`).addClass('ng-touched ng-invalid validate-error');
      $(`#${id}`).removeClass('ng-valid');
    };

    const clearHighlight = (id: string) => {
      $(`#${id}`).removeClass('ng-touched ng-invalid validate-error');
      $(`#${id}`).addClass('ng-valid');
    };

    // Top-level numeric fields
    const totalFundRequested = this.budgetForm.get('totalFundRequested')?.value;
    const totalFundAllocated = this.budgetForm.get('totalFundAllocated')?.value;
    const totalFundConsumed = this.budgetForm.get('totalFundConsumed')?.value;
    const totalFundRetrieved = this.budgetForm.get('totalFundRetrieved')?.value;

    if (totalFundRequested === null || totalFundRequested === '' || totalFundRequested === undefined) {
      $("#totalFundRequested").addClass("ng-touched ng-invalid validate-error");
      $("#totalFundRequested").removeClass("ng-untouched ng-valid");
      //highlight('totalFundRequested');
      messages.push('Total Fund Requested is mandatory.');
      isValid = false;
    } else {
      clearHighlight('totalFundRequested');
    }

    if (!isNaN(totalFundAllocated) && !isNaN(totalFundRequested) && parseFloat(totalFundAllocated) > parseFloat(totalFundRequested)) {
      $("#totalFundRequested").addClass("ng-touched ng-invalid validate-error");
      $("#totalFundRequested").removeClass("ng-untouched ng-valid");
      $("#totalFundAllocated").addClass("ng-touched ng-invalid validate-error");
      $("#totalFundAllocated").removeClass("ng-untouched ng-valid");
      //highlight('totalFundRequested');
      messages.push('Total Fund Requested should be greater than or equal to Total Fund Allocated/Approved.');
      isValid = false;
    }else {
      clearHighlight('totalFundRequested');
      clearHighlight('totalFundAllocated');
    }

    if (!isNaN(totalFundAllocated) && !isNaN(totalFundConsumed) && parseFloat(totalFundAllocated) < parseFloat(totalFundConsumed)) {
      $("#totalFundAllocated").addClass("ng-touched ng-invalid validate-error");
      $("#totalFundAllocated").removeClass("ng-untouched ng-valid");
      highlight('totalFundConsumed');
      messages.push('Total Fund Allocated/Approved should be greater than or equal to Total Fund Consumed.');
      isValid = false;
    }else {
      clearHighlight('totalFundAllocated');
      clearHighlight('totalFundConsumed');
    }

    if (!isNaN(totalFundConsumed) && !isNaN(totalFundRetrieved) && parseFloat(totalFundAllocated) < parseFloat(totalFundRetrieved)) {
      $("#totalFundConsumed").addClass("ng-touched ng-invalid validate-error");
      $("#totalFundConsumed").removeClass("ng-untouched ng-valid");
      messages.push('Total Fund allocated should be greater than or equal to Total Fund Retrieved.');
      isValid = false;
    }else {
      clearHighlight('totalFundConsumed');
      clearHighlight('totalFundRetrieved');
    }

    // Payment Schedule validations (FormArray)
    for (let i = 0; i < this.paymentSchedules.length; i++) {
      const schedule = this.paymentSchedules.at(i);

      const actualRaw = schedule.get('actualPaymentDate')?.value;
      const plannedRaw = schedule.get('plannedPaymentDate')?.value;
      const planned = new Date(schedule.get('plannedPaymentDate')?.value);
      const actual = new Date(schedule.get('actualPaymentDate')?.value);
      const milestoneChecked = schedule.get('milestone')?.value;
      const milestoneType = schedule.get('milestoneType')?.value;

      const actualId = `actualPaymentDate_${i}`;
      const milestoneTypeId = `milestoneType_${i}`;

      if (actualRaw && planned && actual < planned) {
        $("#actualPaymentDate_" + i).addClass("ng-touched ng-invalid validate-error");
        $("#actualPaymentDate_" + i).removeClass("ng-untouched ng-valid");
        messages.push('Actual Payment Date must be after Planned Payment Date.');
        isValid = false;
      } else {
        clearHighlight(actualId);
      }


      if (milestoneChecked && !milestoneType) {
        this.milestoneTypeErrors[i] = true;
        messages.push('Milestone Type is required.');
        isValid = false;
      } else {
        this.milestoneTypeErrors[i] = false;
      }
    }

    if (this.paymentSchedules.length > 0) {
      let filledRowCount = 0;

      for (let i = 0; i < this.paymentSchedules.length; i++) {
        const schedule = this.paymentSchedules.at(i);

        const hasAnyValue =
          ['plannedPaymentDate', 'actualPaymentDate', 'amount', 'allocated', 'fundReceivedBack', 'notes']
            .some(field => {
              const val = schedule.get(field)?.value;
              return val !== null && val !== undefined && val !== '';
            }) ||
          schedule.get('milestone')?.value === true ||
          !!schedule.get('milestoneType')?.value ||
          (schedule.get('attachments')?.value?.length > 0);

        if (hasAnyValue) {
          filledRowCount++;
        }
      }

      if (filledRowCount === 0 || filledRowCount < this.paymentSchedules.length) {
        messages.push('please enter atleast one field.');
        isValid = false;
      }
    }

    if (!isValid) {
      this.commonService.ValidationBanner(messages.join('<br/>'));
    }

    return isValid;
  }

  save() {
    if (!this.validateControls()) return;

    const totalFundAllocated = this.budgetForm.get('totalFundAllocated')?.value;
    const totalFundRequested = this.budgetForm.get('totalFundRequested')?.value;
    const totalFundConsumed = this.budgetForm.get('totalFundConsumed')?.value;
    const totalFundRetrieved = this.budgetForm.get('totalFundRetrieved')?.value;
    
    if(totalFundAllocated == "" || totalFundAllocated == null || totalFundAllocated == undefined){
      this.budgetForm.get('totalFundAllocated')?.setValue(null);
    }
    if(totalFundRequested == "" || totalFundRequested == null || totalFundRequested == undefined){
      this.budgetForm.get('totalFundRequested')?.setValue(null);
    }
    if(totalFundConsumed == "" || totalFundConsumed == null || totalFundConsumed == undefined){
      this.budgetForm.get('totalFundConsumed')?.setValue(null);
    }
    if(totalFundRetrieved == "" || totalFundRetrieved == null || totalFundRetrieved == undefined){
      this.budgetForm.get('totalFundRetrieved')?.setValue(null);
    }

    const amount = this.budgetForm.get('amount')?.value;
    const allocated = this.budgetForm.get('allocated')?.value;
    const fundReceivedBack = this.budgetForm.get('fundReceivedBack')?.value;

    if(amount == "" || amount == null || amount == undefined){
      this.budgetForm.get('amount')?.setValue(null);
    }
    if(allocated == "" || allocated == null || allocated == undefined){
      this.budgetForm.get('allocated')?.setValue(null);
    }
    if(fundReceivedBack == "" || fundReceivedBack == null || fundReceivedBack == undefined){
      this.budgetForm.get('fundReceivedBack')?.setValue(null);
    }

    const formValue = this.budgetForm.getRawValue();
    console.log('Form Value:', formValue);

    this.budgetService.Insert("api/ISTAllRequests/SaveApplicationBudget", formValue).subscribe(result => {
      if (result.Status == 0) {
        this.commonService.SuccessBanner(result.Message);
        this.modalRef.close(result);
      }
      else if (result.Status == 2) {
        this.commonService.ValidationBanner(result.Message);
      }
      else {
        this.commonService.ValidationBanner(result.Message);
      }
    });
  }

  close() {
    this.modalRef.close();
  }

  DeletePayment(index: number): void {
    const paymentSchedules = this.budgetForm.get('paymentSchedules') as UntypedFormArray;

    if (paymentSchedules.length > 0) {
      paymentSchedules.removeAt(index); // this removes the entire FormGroup at that index
    } else {
      this.commonService.ValidationBanner("No payment schedule to delete.");
    }
  }

  ComposeEmail() {
    let modalRef1 = this.modalService.open(EmailComposeComponent, {
      backdrop: false,
      keyboard: false,
      windowClass: 'modal-vlg right modal-right',
      animation: true
    });
    let moduleID = this.ModuleId == 'IST' ? '2' : this.ModuleId == "EAP" ? "5" : '4';
    modalRef1.componentInstance.Content = {
      heading: 'Compose',
      content: { ApplicationID: this.applicationId, ModuleID: moduleID, SubModule: this.SubModule, MailType: "new", SendFrom: "MyAppBudget" }
    }
    modalRef1.result.then(result => {
    })
  }
}
